import {Injectable} from '@angular/core';
import {StammdatenKommunikation} from '@nachdigal';
import {AbstractMapper} from '../../abstract.mapper';
import {MappedStammdatenKommunikationsmittel} from '@utils-lib';
import {InternetadresseMapperService} from './internetadresse-mapper.service';
import {TelefonnummerMapperService} from './telefonnummer-mapper.service';

@Injectable()
export class KommunikationsmittelMapperService extends AbstractMapper<StammdatenKommunikation, MappedStammdatenKommunikationsmittel> {

  constructor(
    private readonly telefonnummernMapper: TelefonnummerMapperService,
    private readonly internetadressenMapper: InternetadresseMapperService
  ) {
    super();
  }

  protected mapInternal(source: StammdatenKommunikation): MappedStammdatenKommunikationsmittel {

    return {
      telefonnummern: this.telefonnummernMapper.mapArrayWithDefault(source.telefonnummern),
      internetadressen: this.internetadressenMapper.mapArrayWithDefault(source.internetadressen)
    };
  }
}
